import React, { Component } from 'react';
import { runValidation } from '../helpers/Validation';
import { getTokenData, scrollToTop } from '../helpers/Common';
import { handleCheckbox, handleRadio, handleSequence, autoFocusNext, allowOnlyNumberInput, countWords } from '../helpers/Fields';
import { domainUrl, rootDomainUrl } from '../config/Config';
import { ObserverEcoachMessage, contentResizeLoad, showSmallLeftMenu, reactLoader, message } from '../helpers/Common';
import Flowplayer from '../components/Flowplayer';
import VoiceRecorder from '../components/VoiceRecorder';
import VirtualKeyboard from '../components/Virtualkeyboard';
import ThanksMessage from './partials/ThanksMessage';
import SelectLearnerObserver from './partials/SelectLearnerObserver';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLearningRoom } from '../actions/learningRoomAction';
import { getActiongoalAction } from '../actions/actiongoalAction';
import Imagezoom from '../components/Imagezoom';
import Confidencemeter from '../components/Confidencemeter';
const $ = window.$;
class BetTest extends Component {
    constructor(props) {
        super(props);
        this.submitObserverandProceed = this.submitObserverandProceed.bind(this);
        this.state = {
            videoTracks: [],
            componentStatus: this.props.data.status,
            observerEvaluation: false,
            evaluationPanel: false,
            showChallengeSelect: false,
            showComponentVideo: false,
            testquestions: [],
            testcont: [],
            statusMessage: "",
            altText: "",
            mcqName: "",
            noOfQuestions: "",
            confidence_meter:"",
            learnerMsg: "",
            showBetQuestions: false,
            amountInHand: 0,
            betType: '1',
            betTheme: '1',
            percentageList: [
                {
                    text: "I can score 90% <br /> or more",
                    value: 970
                },
                {
                    text: "75% or more, <br /> but less than 90%",
                    value: 663
                },
                {
                    text: "65% or more, <br /> but less than 75%",
                    value: 335
                },
                {
                    text: "55% or more, <br /> but less than 65%",
                    value: 150
                }
            ]
        };
    }
    getTestdetails(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'bet-test/gettestdetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                data
            })
        }).then((response) => response.json()).then((responseJson) => {
            let showChallengeSelect = (responseJson.challengeAdded) ? false : true;
            this.setState({
                testquestions: responseJson.McqQuestions,
                testcont: responseJson.Mcq_details,
                betType: responseJson.Mcq_details.bet_type,
                betTheme: responseJson.Mcq_details.bet_theme,
                confidence_meter: responseJson.Mcq_details.confidence_meter,
                altText: responseJson.Mcq_details.alt_text,
                mcqName: responseJson.Mcq_details.mcq_name,
                noOfQuestions: responseJson.Mcq_details.no_of_questions,
                learnerMsg: responseJson.Mcq_details.learner_msg,
                amountInHand: responseJson.amountInHand,
                videoTracks: responseJson.videoTracks,
                observerEvaluation: responseJson.Mcq_details.observerEvaluation,
                showChallengeSelect: showChallengeSelect,
                showBetQuestions: responseJson.challengeAdded,
                statusMessage: ObserverEcoachMessage({
                    evaluation_mentor: responseJson.Mcq_details.evaluationMentor,
                    evaluation_ecoach: responseJson.Mcq_details.evaluationEcoach,
                    mentor_perform: responseJson.Mcq_details.mentorPerform,
                    ecoach_perform: responseJson.Mcq_details.ecoachPerform,
                    mentor_view: responseJson.Mcq_details.mentorView,
                    ecoach_view: responseJson.Mcq_details.ecoachView
                })
            });

            setTimeout(() => {
                contentResizeLoad();
                showSmallLeftMenu();
                contentResizeLoad();
                reactLoader("hide");
            }, 200);
            if (this.state.testcont.imagezoom) {
                $(function () {
                    $('[data-chittizoom]').chittizoom();
                });
            }
        });
    }
    componentDidMount() {
        const { data } = this.props;
        this.getTestdetails(data);
        setTimeout(() => {
            $('audio').on("play", function (me) {
                $('audio').each(function (i, e) {
                    if (e !== me.currentTarget) {
                        this.pause();
                    }
                });
            });
        }, 500)
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.getTestdetails(data);
    }
    backToComponentList() {
        const { data } = this.props;
        this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    }
    gotoresult() {
        const { data } = this.props;
        this.props.switchback({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "testresults",
            "look_before": data.compseq_id,
            "flowresult": true,
            "is_betcomponent":data.is_betcomponent,
            "betallowcomp":'1',
            //confidence_answer:[], for post confident answer to api.
        });
    }
    continueToComplete() {
        this.setState({
            evaluationPanel: true
        })
    }
    chooseScorePlan(e) {

        $("#winingAmountTxt, #loseAmountTxt").text(0);
        $(".toggle").removeClass("active-color");
        $(e.currentTarget).addClass("active-color");
        this.refs.percentageIndex.value = e.currentTarget.dataset.id;
        this.refs.investAmount.value = "";
    }

    chooseScorePlanold(e) {

        if (e.target.checked) {
            $("#winingAmountTxt, #loseAmountTxt").text(0);
            // $(".toggle").removeClass("active-color");
            // $(e.currentTarget).addClass("active-color");
            this.refs.percentageIndex.value = e.target.dataset.id;
            this.refs.investAmount.value = "";
        }

    }



    calculateAmount(evt) {

        $("#winingAmountTxt, #loseAmountTxt").text(0);
        let investAmount = this.refs.investAmount.value.substring(0, 6),
            amountInHand = this.refs.amountInHand.value * .25,
            percentageIndex = parseInt(this.refs.percentageIndex.value);
        if (isNaN(percentageIndex)) {
            alert("Please choose above score plan and continue.");
            this.refs.investAmount.value = "";
        } else if (investAmount > amountInHand) {
            alert("Bet amount should not exceed 25% of cash in hand.");
            this.refs.investAmount.value = "";
        } else if (this.refs.investAmount.value !== "") {
            let percentageValue = this.state.percentageList[percentageIndex].value,
                winAmount = (percentageValue * investAmount) / 100;
            $("#winingAmountTxt").text(winAmount);
            $("#loseAmountTxt").text(investAmount);
            this.refs.winAmount.value = winAmount;
            this.refs.loseAmount.value = investAmount;
            // We can't access refs on unrendered part. So set in state
            this.setState({
                percentage_index: percentageIndex + 1,
                invest_amount: investAmount,
                amount_in_hand: this.refs.amountInHand.value,
                win_amount: winAmount,
                lose_amount: investAmount
            })
        }
    }
    /* hide feb-4 2019
    showBetTestVideo() {
        if (runValidation()) {
            this.setState({
                showChallengeSelect: false,
                showComponentVideo: true
            })
        }
    }
    */
    showBetTestVideo() {
        // console.log(runValidation());return false;
        if (runValidation()) {
            let betType = this.state.betType;
            this.setState({
                showChallengeSelect: false,
                showComponentVideo: (betType === 1) ? true : false,
                //showComponentVideo:  true,
            });
            if (betType === 2)
                this.continueBetTest();

        }
    }

    continueBetTest() {
        const { data } = this.props;
        let ajaxData = JSON.stringify({
            data: data,
            percentage_index: this.state.percentage_index,
            invest_amount: this.state.invest_amount,
            amount_in_hand: this.state.amount_in_hand,
            win_amount: this.state.win_amount,
            lose_amount: this.state.lose_amount
        });
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'bet-test/add-bet', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: ajaxData
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            this.setState({
                showComponentVideo: false,
                showBetQuestions: true
            })
        });
    }
    hintopen(question_id, hint_reduce_per, hint_message) {
        const { data } = this.props;
        window.swal({
            // title: 'Note',
            text: '​Viewing the hint will reduce your score for this question by ' + hint_reduce_per + '%',
            //type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#14a430',
            cancelButtonColor: '#0082c9',
            animation: false,
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result) {
                reactLoader("show", "Please wait...");
                fetch(domainUrl + 'normal-test/addhintstatus', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getTokenData()
                    },
                    body: JSON.stringify({
                        'data': data,
                        'question_id': question_id,
                        'hint_reduce_per': hint_reduce_per
                    })
                }).then((response) => response.json()).then((responseJson) => {
                    if (responseJson.result) {
                        message('Hint!', hint_message, 'info');
                        $('.' + question_id).css('display', 'block');
                    }
                    setTimeout(() => {
                        contentResizeLoad();
                        contentResizeLoad();
                        reactLoader("hide");
                    }, 200);
                });
            }
        });
    }
    submittest() {
        let confidence= this.state.confidence_meter;
        let isValid = true;

      if(confidence==1)
      {
        this.state.testquestions.map((mk,index)=>{
              
          if(document.getElementById('notsure_'+mk.question_id).checked === true  || document.getElementById('somewhatsure_'+mk.question_id).checked === true || document.getElementById('verysure_'+mk.question_id).checked === true)
          {
            isValid= true;
            $('#errorconfident_'+mk.question_id).css('display','none');
            if(document.getElementById('somewhatsure_'+mk.question_id).checked ==true)
            {
              //alert('2');
              //this.state.confidence_answer.push({'confidence_ans': document.getElementById('somewhatsure_'+mk.question_id).value})
              //console.log(this.state.testquestions);
            }
            if(document.getElementById('notsure_'+mk.question_id).checked ==true )
            {
              //alert('1');
              //this.state.confidence_answer.push({'confidence_ans':document.getElementById('notsure_'+mk.question_id).value})
            }
            if(document.getElementById('verysure_'+mk.question_id).checked ==true)
            {
              //alert('3');
              //this.state.confidence_answer.push({'confidence_ans':document.getElementById('verysure_'+mk.question_id).value})
            }
          }
          else
          {
            isValid= false;
            $('#errorconfident_'+mk.question_id).css('display','block');
          }
        })

      }
        
        if (runValidation() && isValid) {
            const { data } = this.props;
            let testForm = $("#frm_mcq").serializeArray(),
                formData = new FormData();
            testForm.map((val, index) => {
                formData.append(val.name, val.value);
            });
            console.log(data);
            formData.append("questions", JSON.stringify(this.state.testquestions));
            formData.append("data", JSON.stringify(data));
            reactLoader("show");
            fetch(domainUrl + "bet-test/saveall", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: formData
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status == 0) {
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    scrollToTop();
                    this.props.getLearningRoom();
                    if (responseJson.componentStatus == 'completed') {
                        this.gotoresult();
                    } else {
                        let evaluationPanel = (responseJson.componentStatus == "incompleted") ? true : false;
                        this.setState({
                            componentStatus: responseJson.componentStatus,
                            evaluationPanel: evaluationPanel
                        })
                    }
                }
            });
        }
    }
    submitObserverandProceed(obj) {
        const { data } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "normal-test/observer-proceed", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                form_data: this.state.testcont,
                observers: obj,
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status == 0) {
                message("OOPS!", "Something went wrong. Please try again later.", "error");
            } else {
                scrollToTop();
                this.props.getLearningRoom();
                this.gotoresult();
            }
        });
    }
    getoptions(ans_opt, imagezoomopt) {
        switch (ans_opt.options) {
            case 'image':
                return (imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl + "admin/test_image_files/" + ans_opt.add_on_answer_image} izalt="" izwidth="150" izheight="150" /> : <img src={rootDomainUrl + "admin/test_image_files/" + ans_opt.add_on_answer_image} alt="" width="150" height="150" />
                break;
            case 'audio':
                return <audio controls controlsList="nodownload">
                    <source src={rootDomainUrl + "admin/test_audio_files/" + ans_opt.add_on_answer_audio} type="audio/mpeg" />
                </audio>
                break;
            case 'video':
                return this.video_frame(ans_opt.add_on_answer_video, '');
                break;
            default:
                return <div dangerouslySetInnerHTML={{ __html: ans_opt.options }}></div>
                break;
        }
    }
    submitbuttons() {
        return <div id="InActive" className="button">
            <input value="Submit" className="button_org_inactive" type="button" onClick={(e) => this.submittest()} />
        </div>
    }
    getquestion(quest_det, ans_opt, i, imagezoomopt) {
        let qty_val = [];
        let question_type = quest_det.question_type;
        let classnam = (ans_opt.options == 'video') ? "vleft" : 'fleft';
        switch (question_type) {
            case 1:
                qty_val = <li key={`list_${quest_det.question_id}_${i}`} className="qleft">
                    <span className="flefts"><input type='radio' name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
                    <span className={classnam}>{this.getoptions(ans_opt, imagezoomopt)}</span>
                </li>
                break;
            case 2:
                qty_val = <li key={`list_${quest_det.question_id}_${i}`} className="qleft"><span className="fleft">{i}. </span>
                    <span className={classnam}>{this.getoptions(ans_opt, imagezoomopt)}</span>
                </li>;
                break;
            case 3:
                qty_val = <li key={`list_${quest_det.question_id}_${i}`} className="qleft">
                    <span className="flefts"><input type='checkbox' name={quest_det.question_id} onClick={(e) => handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} /></span>
                    <span className={classnam}>{this.getoptions(ans_opt, imagezoomopt)}</span>
                </li>;
                break;
            case 4:
                qty_val = <li key={`list_${quest_det.question_id}_${i}`} className="qleft testopt">
                    <span className="sleft">{this.getoptions(ans_opt, imagezoomopt)}</span>
                </li>;
                break;
            case 5:
                qty_val = <li key={`list_${quest_det.question_id}_${i}`} className="qleft">
                    <span className="flefts"><input type='radio' name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
                    <span className={classnam}>{this.getoptions(ans_opt, imagezoomopt)}</span>
                </li>;
                break;
            default:
                qty_val = '';
                break;
        }
        return qty_val;
    }
    matchfillfun(mk, imagezoomopt) {
        let validationClass = (this.state.testcont.allow_skip == 0) ? 'required ' : '';
        validationClass = validationClass + 'sequence';
        return <li key={`list_${mk.question_id}`} className="qleft">
            <p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
            <div className="tab-match-container">
                <table className="tbl-match">
                    <thead>
                        <tr className="tbl-match-head">
                            <td><b>SET A</b></td>
                            <td><b>Correct match from Set B</b></td>
                            <td><b>SET B</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        {mk.mcq_match_filling.map((mc, r) => {
                            return <tr key={`matches_tr_${r}`} className="tbl-match-body">
                                <td>
                                    <div className="statement">
                                        {mc.match_ques_type == 1 && <center>{mc.match_ques_src}</center>}
                                        {mc.match_ques_type == 2 && <center>
                                            {(imagezoomopt) ?
                                                <Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} izalt="" izwidth="200" izheight="200" />
                                                :
                                                <img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} alt="" width="200" height="200" />
                                            }
                                        </center>}
                                        {mc.match_ques_type == 3 && <audio controls controlsList="nodownload">
                                            <source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ques_src} type="audio/mpeg" />
                                        </audio>
                                        }
                                        {mc.match_ques_type == 4 && this.video_frame(mc.match_ques_src, '')}
                                    </div>
                                </td>
                                <td>
                                    <input type="text" name={mk.question_id} className="txtbox matchtxt auto-focus" style={{ width: "90px" }} title="Enter numeric input" maxLength="2" onKeyPress={e => allowOnlyNumberInput(e)} onKeyUp={(e) => autoFocusNext(e, 'tr')} onBlur={(e) => handleSequence(e)} />
                                </td>
                                <td>
                                    <div>
                                        <span style={{ float: "left" }}>{r + 1}. </span>
                                        <div className="statement">
                                            {mc.match_ans_type == 1 && <center>{mc.match_ans_src}</center>}
                                            {mc.match_ans_type == 2 && <center>
                                                {(imagezoomopt) ?
                                                    <Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} izalt="" izwidth="200" izheight="200" />
                                                    : <img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} alt="" width="200" height="200" />}
                                            </center>}
                                            {mc.match_ans_type == 3 && <audio controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ans_src} type="audio/mpeg" /></audio>
                                            }
                                            {mc.match_ans_type == 4 && this.video_frame(mc.match_ans_src, '')}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
                <input type="hidden" name={`${mk.question_id}_hidden`} className={validationClass} data-max-seq={mk.mcq_match_filling.length} defaultValue="" />
            </div>
        </li>
    }
    video_frame(video_files, text) {
        const { data } = this.props;
        let trackData = {
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            learner_id: data.learner_id,
            dlr_id: data.dlr_id,
            compo_type: data.compo_type
        };
        let playlist = {
            share: false,
            ratio: 9 / 16,
            clip: {
                sources: [
                    {
                        type: "video/mp4",
                        src: rootDomainUrl + 'admin/test_video_files/' + video_files
                    }
                ]
            }
        };


        return <Flowplayer key={video_files} playlist={playlist} trackData={trackData} />;
    }
    openendquestions(mk) {
        let validationClass = (this.state.testcont.allow_skip == 0) ? 'required ' : '';

        validationClass = validationClass + 'textbox_big word-count-check';
        return <li key={`list_${mk.question_id}`}>
            <span className="textbox_align1">
                {/* <textarea name={mk.question_id} className={validationClass} rows="3" style={{ height: "inherit", resize: "none" }} onKeyUp={(e) => countWords(e)} data-total-words={mk.openended_maxwords}></textarea> */}
                {(mk.is_virtualkeyboard == 1) ? <VirtualKeyboard qus_id={mk.question_id} validate={validationClass} chkonkeyup={(e) => countWords(e)} data_maxword={mk.openended_maxwords} /> : <textarea name={mk.question_id} id={`keyboard${mk.question_id}`} className={validationClass} rows="3" style={{ height: "inherit", resize: "none" }} onKeyUp={(e) => countWords(e)} data-total-words={mk.openended_maxwords}></textarea>}
                <div className="max-words">
                    <span className="date_red lefttxt">
                        Max words: {mk.openended_maxwords}
                    </span>
                </div>
                <div className="word-count">
                    <span className="balance-words"></span>
                    <span className="typing-words"></span>
                </div>
            </span>
        </li>
    }
    render() {
        let seq_op = [],
            control_style = { width: '50%' };
        const { data } = this.props;
        let imagezoomof = this.state.testcont.imagezoom;
        const percentageListHtml = (this.state.betTheme == 1) ? this.state.percentageList.map((val, key) => {
            return <div key={`percentList${key}`} className={`serv-list${key + 1} toggle`} data-id={key} onClick={e => this.chooseScorePlan(e)} style={{ cursor: "pointer" }}>
                <span dangerouslySetInnerHTML={{ __html: val.text }} />
                <h2><span></span> {val.value}</h2>
            </div>
        }) : this.state.percentageList.map((val, key) => {

                return <tr key={`percentList${key}`}><td><div className="cha-radio-container"><input type="radio" id={`cah-radio${key + 1}`} name="radio-challenge" data-id={key} onChange={e => this.chooseScorePlanold(e)} /><label htmlFor={`cah-radio${key + 1}`}></label></div></td><td><span dangerouslySetInnerHTML={{ __html: val.text }} /></td><td className="text-center">{val.value}</td></tr>
            })


        let trackData = {
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            learner_id: data.learner_id,
            divider_id: data.divider_id,
            dlr_id: data.dlr_id,
            compo_type: data.compo_type
        };
        let betVideoHtml = null;
        let confidence_meter=this.state.confidence_meter;
        //if (this.state.videoTracks.playlist != undefined) {
        if (this.state.videoTracks.length != 0) {
            betVideoHtml = <div className="custom-react-wrapper">
                <div className="lr-gray-box videogray">
                    <Flowplayer playlist={this.state.videoTracks} vcdata={data} trackData={trackData} />
                    <div className="clear"></div>
                </div>
            </div>;
        }
        const challengeHtml = (this.state.betTheme == 1) ? <div className="challenge-box">
            <div className="head">
                <div className="head-left">
                    <img src={process.env.PUBLIC_URL + "/images/simp-log.png"} />
                    <h1>Challenge Setter</h1>
                </div>
                <div className="head-right"><span></span>My Challenge for Quiz</div>
            </div>
            <div className="content-char">
                <span className="spec-head">&nbsp;</span>
                <div className="serv-list">
                    {percentageListHtml}
                    <div className="clear"></div>
                    <input type="hidden" ref="percentageIndex" className="required" />
                </div>
                <div className="char-spec">
                    <p className="new"></p>
                    <div className="left-pad">
                        <img src={process.env.PUBLIC_URL + "/images/money-bag1.png"} />
                        <h2>{this.state.amountInHand}</h2><span>My Points</span>
                    </div>
                    <div className="right-pad">
                        <ul>
                            <li>
                                <label>Enter the points which your are investing</label>
                                <input className="required invest digit" type="text" placeholder="I am investing" ref="investAmount" maxLength="6" data-maxvalue={(this.state.amountInHand > 0) ? this.state.amountInHand : '1000'} data-minvalue="1" onKeyPress={e => allowOnlyNumberInput(e)} onKeyUp={e => this.calculateAmount(e)} />
                            </li>
                            <li>
                                <label>If I meet my challenge the points I will win is </label>
                                <img src={process.env.PUBLIC_URL + "/images/ctick.png"} /><span id="winingAmountTxt">0</span>
                            </li>
                            <li>
                                <label>If I don&#39;t meet my challenge, the points I will lose is </label> &nbsp;&nbsp;&nbsp;
                                <img src={process.env.PUBLIC_URL + "/images/cwrong.png"} /><span id="loseAmountTxt">0</span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <input type="button" value="OK" className="submit" onClick={() => this.showBetTestVideo()} />
                        <input type="hidden" ref="amountInHand" value={this.state.amountInHand} />
                        <input type="hidden" ref="winAmount" />
                        <input type="hidden" ref="loseAmount" />
                    </div>
                </div>
            </div>
        </div> : <div className="challenge-blue">
                <div className="challenge-blue-wrapper">
                    <h2>You are now going to SET A CHALLENGE for yourself for next 10 quiz(zes). Follow the steps:</h2>
                    <div className="step1">
                        <div className="setp1-wrapper">
                            <span className="head-step">STEP 01</span>
                            <h3>Choose a challenge from below.</h3>
                            <div className="table-container">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th ></th>
                                            <th style={{ 'width': '52%' }}>My Challenge for 10 Quiz (zes)</th>
                                            <th >Winning amount for every 50 points invested </th>
                                        </tr>
                                        {percentageListHtml}
                                    </tbody>
                                </table>
                                <input type="hidden" ref="percentageIndex" className="required" />
                            </div>
                        </div>
                    </div>

                    <div className="step2">
                        <div className="money">
                            <img src="images/cha-money-ico.png" /> <span>Money at hand: {this.state.amountInHand}</span>
                        </div>
                        <div className="step2-container">

                            <div className="step2-wrapper">
                                <div className="step2-head">
                                    <span className="head-step">STEP 02</span>
                                    <h4>Enter the amont you are <span>investing on the challenge.</span></h4>
                                </div>
                                <div className="red-bg form-investing">
                                    <p>Enter the investing</p>
                                    <input className="required invest digit" type="text" placeholder="I am investing" ref="investAmount" maxLength="6" data-maxvalue={(this.state.amountInHand > 0) ? this.state.amountInHand : '1000'} data-minvalue="1" onKeyPress={e => allowOnlyNumberInput(e)} onKeyUp={e => this.calculateAmount(e)} />
                                </div>
                                <p className="nxt-redbg">If I meet my challenge, the amount I will win is</p>
                                <div id="winingAmountTxt" className="red-bg info">

                                </div>
                                <p className="nxt-redbg">If I don't meet my challenge, the amount I will lose is</p>
                                <div id="loseAmountTxt" className="red-bg info">

                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="button" value="OK" className="submit" onClick={() => this.showBetTestVideo()} />
                    <input type="hidden" ref="amountInHand" value={this.state.amountInHand} />
                    <input type="hidden" ref="winAmount" />
                    <input type="hidden" ref="loseAmount" />
                </div>
            </div>





        const questionHtml = <div className="custom-react-wrapper">
            {
                this.state.componentStatus === "incompleted" && this.state.evaluationPanel &&
                <div className="custom-react-wrapper">
                    <ThanksMessage message={this.state.statusMessage} />
                    <SelectLearnerObserver submitObserverandProceed={this.submitObserverandProceed} />
                </div>
            }
            {
                this.state.componentStatus === "" &&
                <form name="frm_mcq" id="frm_mcq">
                    {
                        this.state.testquestions.map((mk, index) => {
                            let optionText = [], vcla = (mk.is_hint_viewed > 0) ? 'block' : 'none';
                            let checkboxRadioClass = (mk.allow_skip == 0) ? 'required ' : '',
                                sequenceClass = (mk.allow_skip == 0) ? 'required ' : '',
                                optionClass = (mk.allow_skip == 0) ? 'required ' : '';

                            checkboxRadioClass = checkboxRadioClass + 'max-select-check';
                            sequenceClass = sequenceClass + 'sequence';
                            optionClass = optionClass + 'with-in-options txtbox fillupstxt';

                            return <div key={`a${index}`} className="lr-gray-box test">
                                <div className="graybox_border">
                                    <div className="margbtm para">
                                        {(mk.hint_for_learner != '' && mk.hint_for_learner != undefined) &&

                                            <div key={`hint${index}`} className="test-hint">
                                                <a href="javascript:void(0);" onClick={e => this.hintopen(mk.question_id, mk.hint_reduce_per, mk.hint_for_learner)} title={`​Viewing the hint will reduce your score for this question by ${mk.hint_reduce_per}%`}>Hint</a>
                                                <div style={{ display: vcla }} key={`hv${index}`} className={`hint-viewed ${mk.question_id}`} title="You have already viewed hint for this question">Viewed</div>
                                            </div>
                                        }
                                        <span className="blwetxt" style={{ float: "left" }}>Q{index + 1}.</span>
                                        <span className="quetn" dangerouslySetInnerHTML={{ __html: mk.mcq_question_name }} />
                                        {mk.question_images.map((val, index) => {
                                            if (val != '' && val != undefined) {
                                                return <div key={`imageq${index}`} className="qleft">
                                                    {(imagezoomof) ?
                                                        <Imagezoom izkey={`img_${index}`} izsrc={rootDomainUrl + "admin/test_image_files/" + val} izalt="" izwidth={mk.img_width} izheight={mk.img_height} />
                                                        :
                                                        <img key={`img_${index}`} src={rootDomainUrl + "admin/test_image_files/" + val} alt="" width={mk.img_width} height={mk.img_height} />
                                                    }
                                                </div>
                                            }
                                        })}
                                        {mk.question_audio.map((aval, aindex) => {
                                            if (aval != '' && aval != undefined) {
                                                return <div key={`auq${index}`} className="qleft"><audio key={`audio_${aindex}`} controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + aval} type="audio/mpeg" /></audio></div>
                                            }
                                        })}

                                        {mk.question_video.map((vval, vindex) => {
                                            if (vval != '' && vval != undefined) {
                                                return this.video_frame(vval, '');
                                            }
                                        })}

                                        <div className="test-ques">
                                            <div className="ans-select">

                                                <ul key={`aopt${index}`}>
                                                    {mk.question_type == 4 && <span className=""><b>Your options are: </b></span>}

                                                    {mk.question_option_answers.map((qas, i) => {
                                                        if (mk.question_type == 4) {
                                                            optionText.push(qas.options);
                                                        }
                                                        else if (mk.question_type == 2) {
                                                            seq_op.push(<span key={`span_${i}_${index}`} className="seq-container"><input type="text" name={`${mk.question_id}`} className="seq_txtbox auto-focus" maxLength="2" onKeyPress={e => allowOnlyNumberInput(e)} onKeyUp={(e) => autoFocusNext(e, '.seq-container')} onBlur={(e) => handleSequence(e)} /> -</span>);
                                                        }

                                                        return this.getquestion(mk, qas, i + 1, imagezoomof);
                                                    })}

                                                    {(mk.question_type == 6) && this.openendquestions(mk)}

                                                    {(mk.question_type == 7) && this.matchfillfun(mk, imagezoomof)}

                                                    {
                                                        $.inArray(mk.question_type, [1, 3, 5]) >= 0 &&
                                                        <li><input type="hidden" name={`${mk.question_id}_hidden`} className={checkboxRadioClass} data-max-option={mk.max_multiple} defaultValue="" /></li>
                                                    }

                                                </ul>

                                                {
                                                    mk.question_type == 8 &&
                                                    <VoiceRecorder questionData={mk} />
                                                }

                                                {mk.question_type == 2 && <div>{seq_op}
                                                    <span className="integratestsmalltxt">(Eg: 4 - 3 - 1 - 2.)</span>
                                                    <div><input type="hidden" name={`${mk.question_id}_hidden`} className={sequenceClass} data-max-seq={mk.question_option_answers.length} defaultValue="" /></div>
                                                </div>
                                                }
                                                {mk.question_type == 4 && <span className="integratestsmalltxt">
                                                    Ans:<input type="text" name={mk.question_id} className={optionClass} data-options={optionText.join(',')} />
                                                </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {confidence_meter==1 ? <Confidencemeter dynamic_confidence={mk.question_id}/> : ''}
                                </div>
                            </div>
                        })
                    }

                    {this.submitbuttons()}
                </form>
            }
            {
                this.state.componentStatus === "incompleted" && !this.state.evaluationPanel &&
                <div className="custom-react-wrapper">
                    <div className="ratebox">You have already answered this component.<br />This component will get completed only when you choose Observer(s) to rate your answers.</div>
                    <div style={{ textAlign: "right" }}>
                        <input type="button" className="button_org" value="Continue" title="Continue" onClick={() => this.continueToComplete()} />
                    </div>
                </div>
            }
            {
                this.state.componentStatus === "completed" &&
                <div className="custom-react-wrapper">
                    {
                        /*testResultHtml*/
                    }
                    <div style={{ textAlign: "right" }}>
                        <input type="button" className="button_org" value="Continue" title="Continue" onClick={() => this.backToComponentList()} />
                    </div>
                </div>
            }
        </div>
        return (<div className="main-inner">
            <div className="border-box">
                <div className="title-box">
                    <div className="icon-box ts_complete_button" title={this.state.altText}></div>
                    {this.state.mcqName}<span className="bluetxt">Number of Questions : {this.state.noOfQuestions}</span>
                </div>
                {this.state.componentStatus === "" &&
                    <div style={{ float: "left", padding: "10px 0px 10px 0px", marginLeft: "25px" }}>
                        <div className="editortxt" dangerouslySetInnerHTML={{ __html: this.state.learnerMsg }} />
                    </div>}
                <section id="semana-scroll-inner" className="scroll">
                    <section className="viewport">
                        <section className="overview">
                            <div className="inner-content">
                                {
                                    this.state.showChallengeSelect &&
                                    challengeHtml
                                }
                                {
                                    this.state.showComponentVideo &&
                                    <div>
                                        {betVideoHtml}
                                        <div className="custom-react-wrapper">
                                            <input type="button" value="Continue" onClick={() => this.continueBetTest()} />
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.showBetQuestions &&
                                    questionHtml
                                }
                            </div>
                        </section>
                    </section>
                </section>
            </div>
        </div>)
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getLearningRoom }, dispatch);
}
export default connect(null, mapDispatchToProps)(BetTest);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/BetTest.js